export default theme => ({
  layerItem: {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
  },
  listItemIcon: {
    color: '#000',
  },
  warningContainer: {
    display: 'flex',
    flex: 1,
    alignContent: 'center',
  },
  warningIcon: {
    color: 'yellow',
    marginRight: 5,
  },
  deleteButtonContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    paddingRight: 10,
    marginBottom: 10,
  },
  visibilityIcon: {
    color: '#666',
    marginRight: 5,
  }
});
